module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\n  <my-product-consult-delete></my-product-consult-delete>\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/product/product.component.html
// module id = ./src/app/product/product.component.html
// module chunks = main